export const KLYDO_YELLOW = "#FFD848";
export const KLYDO_BLACK = "#020202";
export const KLYDO_WHITE = "#fdfdfd";
